module.exports = __webpack_public_path__ + "assets/img/contact.075d61e9.jpg";